/* eslint-disable @typescript-eslint/no-explicit-any */
import { FetchResult, InternalRefetchQueriesInclude } from '@apollo/client'

import { atlas } from 'graphql/tags'

import {
  UseOrdersMutationReturnType,
  useOrdersMutation,
} from 'features/Orders/orders.hooks'

const UPDATE_ORDER_INFO = atlas`#graphql
  mutation UpdateOrderInfo($input: UpdateOrderInfoInput) {
    updateOrderInfo(input: $input) {
      updatedOrders {
        edges {
          node {
            id
            termsAndConditions {
              id
              agreesWithTerms
              terms
              platform
              dateModified
              name
              title
            }
            orderComments 
          }
        }
      }
    }
  }
`

atlas`#graphql
  mutation BulkUpdateOrderStatusMutation($input: BulkUpdateOrderStatusInput!) {
    bulkUpdateOrderStatus(input: $input) {
      updatedOrderIds
      errors {
        message
      }
    }
  }
`

export const useUpdateOrderInfo = (
  refetchQueries?:
    | InternalRefetchQueriesInclude
    | ((
        result: FetchResult<
          UseOrdersMutationReturnType,
          Record<string, any>,
          Record<string, any>
        >,
      ) => InternalRefetchQueriesInclude)
    | undefined,
): UseOrdersMutationReturnType =>
  useOrdersMutation(UPDATE_ORDER_INFO, {
    refetchQueries,
  })
